import http, { Http } from '@/lib/http';

function submitOnboardingApplicationCtor(http: Http) {
  return async (projectId: string) => {
    await http.post(`/onboarding/v1/${projectId}/submit-application`);
  };
}

export const submitOnboardingApplication = submitOnboardingApplicationCtor(http);
